import { createSelector } from '@ngrx/store';
import { getUpdateMemberFormFields } from '../getUpdateMemberFormFields';

export const getUpdateMemberFormFieldsData = createSelector(getUpdateMemberFormFields, (updateMemberFormFields) => updateMemberFormFields.data);
